import StatisticsAccount from 'modules/Statistics/AccountConnect/AccountConnect'
import Sagas from 'modules/Statistics/AccountConnect/saga'
import Reducer from 'modules/Statistics/AccountConnect/reducer'

export default StatisticsAccount

export { Sagas, Reducer }
